module.exports = __webpack_public_path__ + "img/byzantine-consensus-how-it-works.43dd25b3.png";